import React, { ReactNode, useEffect, useState } from 'react';
import { makeRequest } from '../requestUtils';
import { IContactType } from '@frontend-workspace/react-shared-lib';
import path from 'path';
import { useLocation } from 'react-router-dom';

export const ContactListContext = React.createContext<Array<IContactType>>([]);
export const ContactListUpdateContext = React.createContext<Function | undefined>(undefined);
const SelectedContactContext = React.createContext<undefined | IContactType>(undefined);
export const SelectedContactUpdateContext = React.createContext<Function>(() => { });
export const GetCurrentCompany = () => React.useContext(SelectedContactContext);
export const ContactListProvider = ({ children }: { children: ReactNode }) => {
  const [contactList, setContactList] = useState<Array<IContactType>>([]);
  const [selectedContact, setSelectedContact] = useState<undefined | IContactType>(undefined);
  const location = useLocation();

  const getUrlContactId = () => {
    const pathName = window.location.pathname;
    const pathParts = pathName.split('/');
    const item = pathParts.length > 2 ? pathParts[2] : "";
    return item;
  }

  useEffect(() => {
    // makeRequest(`v2/contact`).then((contactList: Array<IContactType>) => {
    refreshContactList();
  }, []);
  const refreshContactList = () => {
    makeRequest("companies").then((contactList: Array<IContactType>) => {
      const urlContact = contactList.find((contact: IContactType) => contact.number === getUrlContactId());
      setContactList(contactList);
      setSelectedContact(urlContact);
    });

  }

  useEffect(() => {
    const urlContact = contactList.find((contact: IContactType) => contact.number === getUrlContactId());
    setContactList(contactList);
    setSelectedContact(urlContact);
  }, [location]);

  return (
    <ContactListUpdateContext.Provider value={refreshContactList}>
      <ContactListContext.Provider value={contactList}>
        <SelectedContactUpdateContext.Provider value={setSelectedContact}>
          <SelectedContactContext.Provider value={selectedContact}>
            {children}
          </SelectedContactContext.Provider>
        </SelectedContactUpdateContext.Provider>
      </ContactListContext.Provider>
    </ContactListUpdateContext.Provider>
  );
}